/**
 * Check if the element is in the viewport
 *
 * @param el
 * @returns {boolean}
 */
function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();

  return (
    rect.left >= 0 &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export default isElementInViewport;
